import { useState } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { separateNum } from "../../../utils";
import { setUser } from "../../../store/action/auth";
import { cartsChanged } from "../../../store/action/cart";
import CartService from "../../../services/cart/Cart";
import HttpService from "../../../services/http_service/HttpService";
import Http from "../../../services/http/Http";
import { Warning } from "../../../components/button";
import Card from "../../../components/card";
import SideBar from "../SideBar";
// import Shippings from "./shipings";
import Addressess from "./addresses";
import Paymethods from "./paymethods";
import Coupon from "./coupon";
// import Products from "./products";
import { Div, Row, Col, TitleAlert, IconAlert } from "./style";
import Notification from "../../../services/notification/Notification";

const Checkout = (props) => {
  let history = useHistory();

  const { user, carts, cartsChanged, theme, settings } = props;

  const [isLoadingSendData, setIsLoadingSendData] = useState(false);

  const handleSubmit = () => {
    if (CartService.getCartPrice(carts)?.price > settings.min_order) {
      if (carts?.paymethod_id) {
        if (isLoadingSendData === false) {
          setIsLoadingSendData(true);

          HttpService(user?.token)
            .post("carts/checkout", {
              paymethod_id: carts?.paymethod_id,
            })
            .then((response) => {
              CartService.setCart(false, cartsChanged);

              if (response?.data?.entity) {
                window.location.replace(response?.data?.entity);
              } else {
                history.push("/profile/orders?status=true");
              }
            })
            .catch((error) => {
              Http(
                error?.response?.status,
                error?.response?.data?.message,
                props
              );

              var errorRes = error?.response?.data?.entity;

              if (errorRes?.cart_not_valid) {
                history.push("/carts");

                CartService.setCart(errorRes?.cart || false, cartsChanged);
              }
            })
            .finally(() => {
              setIsLoadingSendData(false);
            });
        }
      } else {
        Notification.danger("ابتدا یک روش پرداخت را انتخاب کنید");
      }
    } else {
      Notification.danger(
        `سفارش شما باید حداقل ${separateNum(settings.min_order)} تومان باشد.`
      );
    }
  };

  return (
    <>
      <Div className="mt-3 mx-1">
        <Row className="row no-gutters">
          {carts.cart_updated ? (
            <Col className="col-12 mt-1 text-right">
              <div className="alert alert-danger">
                سبد خرید شما تغییر کرده مجدد چک کنید.
              </div>
            </Col>
          ) : (
            ""
          )}

          {/* <Col className="col-12 text-right">
            <Card className="py-2-5 px-2 mb-2 f-12">
              <IconAlert
                className="far fa-clipboard-list vertical-align-bottom f-15 pt-1"
                theme={theme}
              ></IconAlert>
              <TitleAlert className="mr-1" theme={theme}>
                جزییات سفارش شما
              </TitleAlert>
            </Card>
          </Col>
          <Col className="col-12 text-right mb-1">
            <Products />
          </Col>
          <Col className="col-12 text-right">
            <Card className="py-2-5 px-2 mb-2 f-12">
              <IconAlert
                className="far fa-shipping-fast vertical-align-bottom f-15 pt-1"
                theme={theme}
              ></IconAlert>
              <TitleAlert className="mr-1" theme={theme}>
                نحوه ارسال
              </TitleAlert>
            </Card>
          </Col>
          <Col className="col-12 text-right mb-2">
            <Shippings />
          </Col> */}
          {carts?.shipping?.id !== 2 && (
            <>
              <Col className="col-12 text-right">
                <Card className="py-2-5 px-2 mb-2 f-12">
                  <IconAlert
                    className="far fa-map-marker-alt f-15 pt-1"
                    theme={theme}
                  ></IconAlert>
                  <TitleAlert className="mr-1" theme={theme}>
                    آدرس برای ارسال
                  </TitleAlert>
                </Card>
              </Col>
              <Col className="col-12 text-right mb-2">
                <Addressess />
              </Col>
            </>
          )}
          <Col className="col-12 text-right">
            <Card className="py-2-5 px-2 mb-2 f-12">
              <IconAlert
                className="fal fa-sack f-15 pt-1"
                theme={theme}
              ></IconAlert>
              <TitleAlert className="mr-1" theme={theme}>
                شیوه پرداخت
              </TitleAlert>
            </Card>
          </Col>
          <Col className="col-12 text-right mb-2">
            <Paymethods />
          </Col>
          <Col className="col-12 text-right mb-2">
            <Coupon />
          </Col>
          <SideBar>
            <Warning
              title="تایید و پرداخت"
              className="d-block mt-3"
              onClick={handleSubmit}
              isLoading={isLoadingSendData}
              sizeSpinner={20}
            />
          </SideBar>
        </Row>
      </Div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.user,
    carts: state.carts?.carts,
    settings: state.settings?.settings,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser, cartsChanged })(Checkout);
